import { defaultFormState } from '@/presentation/components/models';
import { atom } from 'recoil';
export const manageStudentsAtom = atom({
    key: 'manageStudentsAtom',
    default: {
        isLoading: false,
        modalClass: false,
        classList: [],
        teachers: [],
        idClassCSV: 0,
        modalCheckout: false,
        //
        isTableLoading: false,
        filters: { input: '', deleted: false, selectedClassId: '0', selectedGradeId: null },
        checked: false,
        classes: [],
        grades: [],
        reloadStudents: false,
        reloadClasses: false,
        students: { data: [], count: 0, page: 0, pageCount: 0, total: 0 },
        allStudents: [],
        dataNotFound: false,
        isSemiAnnualPlan: 'error',
        modalLimitExceeded: false,
        modalCheckoutSuccess: false,
        totalStudentsCreated: 0
    }
});
export const selectClassAtom = atom({
    key: 'selectClassAtom',
    default: Object.assign(Object.assign({}, defaultFormState), { classGrade: null, className: '', idAssignedTeacher: null, idClassSelected: null, create: false, idClassSelectedError: '' })
});
